import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import SlogDetail from "../views/SlogDetail.js";
import SlogList from "../views/SlogList.js";
import Favorites from "../views/Favorites.js";
import { Loader } from "../views/Loader.js";

/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout.js"));

/***** Pages ****/
const Starter = lazy(() => import("../views/Starter.js"));
const Gallery = lazy(() => import("../views/Gellery.js"));
const About = lazy(() => import("../views/About.js"));

/*****Routes******/
const ThemeRoutes = [
  {
    path: "/",
    element:
      <Suspense fallback={<Loader />}>
        <FullLayout />
      </Suspense>,
    children: [
      { path: "/", element: <Navigate to="/starter" /> },
      { path: "/starter", exact: true, element: <Starter /> },
      { path: "/gallery", exact: true, element: <Gallery /> },
      { path: "/fav", exact: true, element: <Favorites /> },
      { path: "/slog/:id", exact: true, element: <SlogList /> },
      { path: "/slog/:slogId/detail/:id", exact: true, element: <SlogDetail /> },
      { path: "/about", exact: true, element: <About /> },
    ],
  },
];

export default ThemeRoutes;
